(ns minorodata.connections.sources.hubspot
  (:require [minorodata.app.utils :as app.utils]))


(def source
  {:enabled      false
   :id           "hubspot"
   :name         "HubSpot (Deprecated)"
   :image-source "hubspot.svg"
   :description  "A full stack of software for marketing, sales, and customer service"
   :tags         ["admin-finance"]


   :preview-formatter
   (fn []
     (str "Authenticated with an API key"))

   :form
   {:format-for-api
    (fn [data]
      (let [{:keys [api-key name description]} data]
        {:source-type "hubspot"
         :name        name
         :description description

         :source
         {:credentials {:api-key api-key}}}))

    :format-for-inputs
    (fn [data]
      (let [{:keys [source name description]} data
            {:keys [credentials]} source]
        (merge {:name        name
                :description description}
               (select-keys credentials [:api-key]))))

    :validate (constantly nil)

    :id :hubspot-form

    :blocks [{:block-type :input
              :label      "Source name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}
             {:content "Authentication"
              :block-type :subtitle}
             {:content "Enter information required to connect to Hubspot"}
             {:block-type :input
              :label      "API Key"
              :name       :api-key
              :type       :password
              :required   true
              :value      ""}

             {:block-type :submit
              :content    "SAVE"}]}


   :extract-form
   {:format-for-api
    (fn [{:keys [name description status report action destination-table extract-type]}]
      {:name          name
       :description   description
       :status        status
       :output-tables [destination-table]
       :config
       {:extracts [{:action            action
                    :report            report
                    :extract-type      extract-type
                    :destination-table destination-table}]}})

    :format-for-inputs
    (fn [data]
      (let [{:extract/keys [name description status config]} data

            extract (get-in config [:extracts 0])]
        (merge
         (select-keys extract [:destination-table :report :action :extract-type])
         (app.utils/keep-non-nil-keys
          {:name          name
           :description   description
           :status        status
           :output-tables []}))))

    :validate (constantly nil)

    :id :hubspot-extract-form

    :blocks [{:block-type :input
              :label      "Extract name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :select
              :label      "Status"
              :name       :status
              :options    [{:name "Active" :value "active"}
                           {:name "Paused" :value "paused"}]
              :required   true
              :value      "active"}

             {:block-type :subtitle
              :content    "Extract Configuration"}

             {:block-type :select
              :label      "Report"
              :name       :report
              :options    [{:name "Call Dispositions (Legacy)" :value "legacy-call-dispositions"}
                           {:name "Contacts"  :value "contacts"}
                           {:name "Companies" :value "companies"}
                           {:name "Deals"     :value "deals"}
                           {:name "Engagements (Legacy)" :value "legacy-engagements"}
                           {:name "Marketing Emails (Legacy)" :value "legacy-marketing-emails"}
                           {:name "Tickets"   :value "tickets"}]
              :required   true
              :value      "contacts"}

             {:block-type :select
              :label      "Extract type"
              :name       :extract-type
              :options    [{:name "Full"        :value "full-load"}
                           {:name "Incremental" :value "incremental"}]
              :required   true
              :value      "full-load"}

             {:content "Incremental will fetch all data that was modified since the last extract was run. The HubSpot API limits the result set to 10,000 items in this case. Good for tracking change"
              :conditions [[:eq [:extract-type :value] "incremental"]]}

             {:block-type :subtitle
              :content    "Data loading options"}

             {:block-type :select
              :label      "Load method"
              :name       :action
              :options    [{:name "Drop, Create, Load" :value "replace"}
                           {:name "Truncate, Load"     :value "reload"}
                           {:name "Append"             :value "append"}]
              :required   true
              :value      "replace"}

             {:content "Drop table, Create table, load entire table (selected columns)"
              :conditions [[:eq [:action :value] "replace"]]}

             {:content "Truncate table, Load entire table (selected columns)"
              :conditions [[:eq [:action :value] "reload"]]}

             {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
              :conditions [[:and [[:action :value] [:extract-type :value]] ["append" "full-load"]]]}

             {:content "Find max record in destination table of specified incremental key. Select rows where results of incremental key greater than max record of incremental key in destination table. Insert rows (selected columns) into the destination table no truncation."
              :conditions [[:and [[:action :value] [:extract-type :value]] ["append" "incremental"]]]}

             {:block-type :subtitle
              :content    "Destination table"}

             {:block-type  :warehouse-destination
              :name        :destination-table}

             {:block-type :submit
              :content    "SAVE"}]}})
